import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import IconSvg from "../../../../SharedComponents/IconSvg";

const GradientCard = ({ header, hasImage, hasBottomImage, contentList, imageSrc, onClick }) => {
  return (
    <div className={"gradient-card-wrapper h-100"}>
      <div
        className={`gradient-card h-100 show-cursor  ${!hasImage && !hasBottomImage && " subtle-background"}  ${hasBottomImage && " has-bottom-image h-100 align-content-end"}`}
        onClick={onClick}
      >
        <div
          style={{
            minWidth: "100%",
            maxHeight: "330px",
            aspectRatio: hasBottomImage ? "auto" : "9 / 16",

            overflow: "hidden",
            position: "relative",
            zIndex: hasBottomImage ? 1 : 0,
          }}
        >
          {hasImage && (
            <Image
              src={imageSrc}
              alt="example"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover", // key: makes image fill and crop
                objectPosition: "center", // optional: center the crop
              }}
            />
          )}

          {hasBottomImage && (
            <img
              src={imageSrc}
              alt="example"
              style={{
                padding: "0px 20px",
                width: "100%",
                height: "100%",
                objectFit: "cover",
                WebkitMaskImage: "linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 95%)",
                WebkitMaskRepeat: "no-repeat",
                WebkitMaskSize: "100% 100%",
                maskImage: "linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 95%)",
                maskRepeat: "no-repeat",
                maskSize: "100% 100%",
              }}
            />
          )}
        </div>
        <Row className={"card-content  mx-0"}>
          <Col>
            <Row className={"justify-content-center mt-3"}>
              <Col xs={"auto"}>
                <IconSvg icon={"tick-with-gradient-bg"}></IconSvg>
              </Col>
              <Col xs={"auto"} className={"ps-0 fw-medium text-black text-20"} style={{ letterSpacing: "-1px" }}>
                {header}
              </Col>
            </Row>
            <Row className={" mt-3"}>
              <Col>
                <ul className={"text-color-primary text-18 fw-medium"}>
                  {contentList?.map((itemText, index) => {
                    return (
                      <li key={index} className={"py-1"}>
                        {itemText}
                      </li>
                    );
                  })}
                </ul>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
};
export default GradientCard;
